module.exports = __webpack_public_path__ + "img/wrcsfw-ldys-gzy.e602d30c.png";